import { cn } from "@krea/shared/utils";

export type IndicatorRisk = "GREEN" | "YELLOW" | "RED";

export const Indicator = ({
  className,
  risk,
}: {
  className?: string;
  risk?: IndicatorRisk | null;
}) => {
  return (
    <div
      className={cn(
        "size-5 rounded-full overflow-hidden bg-black-100/50",
        {
          "bg-mint-400": risk === "GREEN",
          "bg-orange": risk === "YELLOW",
          "bg-red": risk === "RED",
        },
        className,
      )}
    />
  );
};
